
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import HeaderGroup from '../HeaderGroup/index.vue'
import GuildRuleModal from '../GuildRuleModal/index.vue'
import { Observer } from 'mobx-vue'
import type { CityTypeInfo } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { dataSource_topicMoreOpions } from '@xt/client/dataSource/kindred-spirit/index'
import { EnumMoreOptions } from '@xt/client/enums/kindred-spirit'
import { EnumCityStatus } from '@xt/client/entities/kindred-spirit/guild'

@Observer
@Component({
  components: {
    HeaderGroup,
    GuildRuleModal
  }
})
export default class IntroPanel extends Vue {
  @Prop({ required: true }) readonly dataSource!: CityTypeInfo
  @Prop({ required: true }) readonly hasJoin!: boolean
  @Prop({ required: true }) readonly isJoinCity!: boolean
  @Prop({ required: true }) readonly isManager!: boolean

  showMenu: boolean = false

  @Ref()
  guildRuleModal: {
    show: () => void
  }

  get EnumCityStatus() {
    return EnumCityStatus
  }

  get showRecruitBtn() {
    return this.dataSource.recruitStatus === true
  }

  get moreOptions() {
    return dataSource_topicMoreOpions.filter(i => {
      if (i.key === EnumMoreOptions.Exit && !this.isJoinCity) return false

      if (i.key === EnumMoreOptions.Manager && !this.isManager) return false

      return true
    })
  }

  get memberIds() {
    return this.dataSource.memberIds ?? []
  }

  get bgImg() {
    return this.dataSource.cover || this.$images.topic_intro_bg_img
  }

  openRuleModal() {
    if (!this.guildRuleModal) return

    this.guildRuleModal.show()
  }

  openMenu() {
    this.showMenu = true
  }

  hideMenu() {
    this.showMenu = false
  }

  handleOperation({ key }: { key: EnumMoreOptions }) {
    switch (key) {
      case EnumMoreOptions.List:
        this.$router.push('/topic/city-list')
        break
      case EnumMoreOptions.Manager:
        this.$router.push('/topic/manager')
        break
      case EnumMoreOptions.Exit:
      default:
        break
    }
    this.showMenu = false
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
